import { sendGet } from './dataUtilities';
import env from '../env';

export const getProductData = (sku: string) => sendGet(`${env.aceApiBaseUrl}/api/products/sku?campaignType=SHOP&sku=${sku}`, {});

export const getUserCartItems = () => sendGet(`${env.aceApiBaseUrl}/public/api/1/carts/campaigns?campaignType=SHOP`, {});

export const getAccountData = () => {
  const headers = {
    'FFF-Auth': 'V1.1',
    accept: 'application/vnd.fabfitfun.v2+json',
  };
  return sendGet(`${env.aceApiBaseUrl}/api/1/accounts`, { headers });
};
